import { Route, Routes } from 'react-router-dom';
import BemVindo from '../pages/BemVindo.js';
import AcaoSocial from '../pages/AcaoSocial.js';
import AvisoLegal from '../pages/AvisoLegal.js';
import Agendas from '../pages/Agendas.js';
import Agenda from '../pages/Forms/Agenda.js';
import Avisos from '../pages/Avisos.js';
import Aviso from '../pages/Forms/Aviso.js';
import Sobre from '../pages/Sobre.js';
import Contatos from '../pages/Contatos.js';
import Contato from '../pages/Forms/Contato.js';
import Eventos from '../pages/Eventos.js';
import Admin from '../pages/Admin.js';
import Associados from '../pages/Associados.js';
import Cadastro from '../pages/Forms/Cadastro.js';
import Prestacoes from '../pages/Prestacoes.js';
import Prestacao from '../pages/Forms/Prestacao.js';
import Lancamentos from '../pages/Lancamentos.js';
import Lancamento from '../pages/Forms/Lancamento.js';
import AreaDoAssociado from '../pages/AreaDoAssociado.js';
import Login from '../pages/Login.js';
import Reset from '../pages/Forms/Reset.js';
import Documentos from '../pages/Documentos.js';
import EnviarDocumento from '../pages/Forms/EnviarDocumento.js';
import Documento from '../pages/Forms/Documento.js';
import ViewPDF from '../pages/ViewPDF.js';
import Mensalidades from '../pages/Mensalidades.js';
import MapaAnual from '../pages/MapaAnual.js';
import Mensalidade from '../pages/Forms/Mensalidade.js';
import EnviarRecibo from '../pages/Forms/EnviarRecibo.js';
import ModelosEmails from '../pages/ModelosEmails.js';
import ModeloEmail from '../pages/Forms/ModeloEmail.js';
import Logs from '../pages/Logs.js';
import Produtos from '../pages/Produtos.js';
import Produto from '../pages/Forms/Produto.js';
import ValidarMembro from '../pages/ValidarMembro.js';
import Assembleias from '../pages/Assembleias.js';
import Assembleia from '../pages/Forms/Assembleia.js';
import Votacoes from '../pages/Votacoes.js';
import Votacao from '../pages/Forms/Votacao.js';
import Votar from '../pages/Forms/Votar.js';
import Resultado from '../pages/Resultado.js';
import Testehtml from '../pages/Testehtml.js';



function RoutesComponent() {
  return (
    <Routes>
        <Route path="/" element={<BemVindo />} />
        <Route path="/AcaoSocial" element={<AcaoSocial />} />
        <Route path="/Agenda" element={<Agenda />} />
        <Route path="/Agendas" element={<Agendas />} />
        <Route path="/Avisos" element={<Avisos />} />
        <Route path="/Aviso/:idaviso" element={<Aviso />} />
        <Route path="/Sobre" element={<Sobre />} />
        <Route path="/Contatos" element={<Contatos />} />
        <Route path="/Contato/:idcontato" element={<Contato />} />
        <Route path="/Eventos" element={<Eventos />} />
        <Route path="/Admin" element={<Admin />} />
        <Route path="/Associados" element={<Associados />} />
        <Route path="/AvisoLegal" element={<AvisoLegal />} />
        <Route path="/Cadastro" element={<Cadastro />} />
        <Route path="/Mensalidades" element={<Mensalidades />} />
        <Route path="/Mensalidade/:ano/:mes" element={<Mensalidade />} />
        <Route path="/MapaAnual" element={<MapaAnual />} />
        <Route path="/MapaAnual/:idPessoa" element={<MapaAnual />} />
        <Route path="/EnviarRecibo" element={<EnviarRecibo />} />
        <Route path="/Prestacoes" element={<Prestacoes />} />
        <Route path="/Prestacao" element={<Prestacao />} />
        <Route path="/Lancamentos" element={<Lancamentos />} />
        <Route path="/Lancamentos/:idPrestacaoDeContas" element={<Lancamentos />} />
        <Route path="/Lancamento" element={<Lancamento />} />
        <Route path="/AreaDoAssociado" element={<AreaDoAssociado />} />
        <Route path="/Login" element={<Login />} />
        <Route path="/Assembleias" element={<Assembleias />} />
        <Route path="/Assembleia/:idAssembleia" element={<Assembleia />} />
        <Route path="/Reset/:codigo" element={<Reset />} />
        <Route path="/Documentos" element={<Documentos />} />
        <Route path="/EnviarDocumento/:IdDocumento" element={<EnviarDocumento />} />
        <Route path="/Documento" element={<Documento />} />
        <Route path="/ViewPDF" element={<ViewPDF />} />
        <Route path="/ModelosEmails" element={<ModelosEmails />} />
        <Route path="/ModeloEmail" element={<ModeloEmail />} />
        <Route path="/Logs" element={<Logs />} />
        <Route path="/Produtos" element={<Produtos />} />
        <Route path="/Produto" element={<Produto />} />
        <Route path="/ValidarMembro/:codigo" element={<ValidarMembro />} />
        <Route path="/Votacoes" element={<Votacoes />} />
        <Route path="/Votacao/:idvotacao/:idassembleia" element={<Votacao />} />
        <Route path="/Votar/:IdVotacao/:pesCodigoGUID/:origem" element={<Votar />} />
        <Route path="/Resultado/:idVotacao" element={<Resultado />} />
        <Route path="/Testehtml" element={<Testehtml />} />
        <Route path="*" element={<BemVindo />} />
    </Routes>
  );
}

export default RoutesComponent;